export enum Role {
  SuperAdmin = 0,
  Admin = 1,
  IndividualInvestor = 2,
  CompanyRep = 3,
  IssuerRep = 4,
  // ENB-70 / ADR-0027: a dedicated copy-editor account. Deliberately NOT one of the three roles
  // that resolve into LoginProfile.role — see login-profile.ts.
  TranslationEditor = 7,
  Public = 99,
}
